import { render, staticRenderFns } from "./documentPack.vue?vue&type=template&id=09655661&"
import script from "./documentPack.vue?vue&type=script&lang=js&"
export * from "./documentPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports